// This file was auto generated by resource-sync tools.

import en_parker from './en/parker.json';
import zh_parker from './zh/parker.json';
import zhHK_parker from './zh-HK/parker.json';


const resources = {
    'en': {
        parker: en_parker
    },
    'zh': {
        parker: zh_parker
    },
    'zh-HK': {
        parker: zhHK_parker
    }
};

export default resources;